import UserDetail from "./Model/UserDetail"
import { ObservableFromFetch } from "../ObservableFromFetch"
import GridResponse from "../GridResponse"
import { Filter, Sort } from "../GridRequest"

const Columns = ["Account", "InActive", "LastLogin", "LoginName", "Role", "UserName", "ProfileStatuses", "SendingFacility", "InvitationSent", "EnrollmentStarted", "Status"] as const
type Column = typeof Columns[number]

export type ColumnFilters = Record<Column, string[]>
export type UserDetailGridResponse = GridResponse<UserDetail> & ColumnFilters

function columnFilters(filters: Filter[]): ColumnFilters {
  return {
    Account: filters.find(filter => filter.column === "Account")?.values || [],
    InActive: filters.find(filter => filter.column === "InActive")?.values.map(status => {return status === "Inactive" ? "true" : "false"}) || [],
    LoginName: filters.find(filter => filter.column === "LoginName")?.values || [],
    LastLogin: filters.find(filter => filter.column === "LastLogin")?.values || [],
    Role: filters.find(filter => filter.column === "Role")?.values || [],
    UserName: filters.find(filter => filter.column === "UserName")?.values || [],
    ProfileStatuses: filters.find(filter => filter.column === "ProfileStatuses")?.values || [],
    SendingFacility: filters.find(filter => filter.column === "SendingFacility")?.values || [],
    InvitationSent: filters.find(filter => filter.column === "ModifiedOn")?.values || [],
    EnrollmentStarted: filters.find(filter => filter.column === "EnrollmentStarted")?.values || [],
    Status: filters.find(filter => filter.column === "Status")?.values || [],
  }
}

export default function UserDetailsObservable(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], implementationID: number | undefined = undefined, companyID: number | undefined = undefined) {
  var params: object = {
    Filters: columnFilters(filters),
    IsQuickStart: false,
    PageNumber: pageNumber,
    PageSize: pageSize || 20,
    SortGrid: { SortColumn: sort.column || "", SortOrder: sort.order.toUpperCase() === "DESC" ? "DSC" : sort.order.toUpperCase()},
    ImplementationID: implementationID || 0,
    CompanyID: companyID || 0
  }

  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<UserDetailGridResponse>("FFOrderUserFileMaintenance/GetUserDetails", requestBody)
}

export function UserDetailsCSVObservable(isSiteAdmin: boolean, pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], implementationID: number | undefined = undefined, companyID: number | undefined = undefined) {
  var params: object = {
    Filters: columnFilters(filters),
    IsQuickStart: false,
    PageNumber: pageNumber,
    PageSize: pageSize || 20,
    isSiteAdmin: isSiteAdmin,
    SortGrid: { SortColumn: sort.column || "", SortOrder: sort.order.toUpperCase() === "DESC" ? "DSC" : sort.order.toUpperCase() }
  }
  if (implementationID) {
    params = { ...params, ImplementationID: implementationID }
  }
  if (companyID) {
    params = { ...params, CompanyID: companyID }
  }
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<string>("FFOrderUserFileMaintenance/GetUserDetailsCSV", requestBody)
}



